import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Antes gastaba un montón en verduras todas las semanas. Empecé con esto y en poco tiempo ya estaba sacando cosas de mi balcón. Es mucho más simple de lo que pensaba.',
    name: 'Lucas M.',
    location: 'Buenos Aires'
  }, {
    quote: 'No tenía idea de nada. Literal cero experiencia. Seguí los pasos y me funcionó. Hoy compro mucho menos en el súper.',
    name: 'Carla R.',
    location: 'Córdoba'
  }, {
    quote: 'Lo mejor es que no necesitás espacio. Arranqué con macetas chicas y ya estoy viendo resultados.',
    name: 'Mariana G.',
    location: 'Rosario'
  }, {
    quote: 'Probé otras cosas y nunca me salían. Esto es distinto porque es simple y directo.',
    name: 'Diego F.',
    location: 'Mendoza'
  }];
  return <section className="w-full py-8 md:py-16 px-4 bg-white" data-id="element-254">
      <div className="max-w-6xl mx-auto" data-id="element-255">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-center text-gray-900 mb-8 md:mb-12" data-id="element-256">
          💬 Lo que dicen personas reales
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-257">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream border-2 border-green-100 rounded-xl p-5 md:p-6 relative hover:border-lime-300 transition-colors" data-id="element-258">
              <Quote className="w-8 h-8 text-lime-300 absolute top-4 right-4 opacity-50" data-id="element-259" />

              <div className="flex gap-1 mb-3" data-id="element-260">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-lime-500 text-lime-500" data-id="element-261" />)}
              </div>

              <p className="text-sm md:text-base text-gray-800 mb-5 italic relative z-10 font-medium" data-id="element-262">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-263">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-800 rounded-full flex items-center justify-center text-white font-bold text-lg" data-id="element-264">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-265">
                  <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-266">
                    {testimonial.name}
                  </p>
                  <p className="text-xs md:text-sm text-gray-600 font-medium" data-id="element-267">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}